import * as React from "react";
import Session from "services/Session";
import { UserShortView, UserEntityModel } from "models/ApiModels";
import i18next from "i18next";

////////////////////////////////////////////////////////////////////////////////

export function UserIdResolver(user: UserEntityModel | UserShortView): string {
    return 'userId' in user
        ? (user as UserEntityModel).userId
        : (user as UserShortView).id;
}

////////////////////////////////////////////////////////////////////////////////

export function getFirstName(name: string) {
    if (name != null) {
        const arr = name.split(' ');
        if (arr.length > 0) return arr[0];
    }
    return name;
}

////////////////////////////////////////////////////////////////////////////////

export function UsernameResolver(user: UserEntityModel | UserShortView, firstNameOnly: boolean = false): string {
    var id = UserIdResolver(user);

    if (id == Session.user?.id)
        return i18next.t("Glossary.You");

    if (user.isSystemUser)
        return i18next.t("Common.Literals.SystemUser");

    let name = user.name;

    if (firstNameOnly && name != null) {
        name = getFirstName(name);
    }

    return name;
}

////////////////////////////////////////////////////////////////////////////////


interface IProps {
    user: UserEntityModel | UserShortView;
    firstNameOnly?: boolean;
}

type Props = IProps;

const UsernameInspect: React.FC<Props> = (props) => {

    var id = UserIdResolver(props.user);
    var name = UsernameResolver(props.user);

    return (id == Session.user.id)
        ? <b>{name}</b>
        : <span>{name}</span>;
};

UsernameInspect.defaultProps = {
    firstNameOnly: false
};

export default UsernameInspect;